(function () {
  function csrfToken() {
    const node = document.querySelector("meta[name='csrf-token']");
    return node ? node.getAttribute("content") : "";
  }

  function applyTheme(theme) {
    document.body.setAttribute("data-theme", theme);

    const toggle = document.querySelector("[data-theme-toggle]");
    if (toggle) {
      toggle.setAttribute("data-theme-current", theme);
      const label = toggle.querySelector(".theme-switch-label");
      if (label) label.textContent = theme === "dark" ? "Dark" : "Light";
    }

    document.cookie = `theme_preference=${theme}; path=/; max-age=${60 * 60 * 24 * 365}; SameSite=Lax`;

    document.querySelectorAll("iframe[data-theme-aware-iframe]").forEach((iframe) => {
      try {
        const url = new URL(iframe.getAttribute("src"), window.location.origin);
        url.searchParams.set("theme", theme);
        // Force fresh widget HTML after theme/layout updates.
        url.searchParams.set("rev", Date.now().toString());
        iframe.setAttribute("src", `${url.pathname}${url.search}`);
      } catch (_e) {
        // ignore invalid iframe URL
      }
    });
  }

  function persistTheme(theme) {
    return fetch("/theme", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "X-CSRF-Token": csrfToken()
      },
      credentials: "same-origin",
      body: JSON.stringify({ theme: theme })
    });
  }

  function initThemeToggle() {
    const toggle = document.querySelector("[data-theme-toggle]");
    if (!toggle || toggle.dataset.bound === "1") return;
    toggle.dataset.bound = "1";

    toggle.addEventListener("click", () => {
      const current = toggle.getAttribute("data-theme-current") === "light" ? "light" : "dark";
      const next = current === "dark" ? "light" : "dark";

      applyTheme(next);
      persistTheme(next).catch(() => {
        // local UI state already switched; server sync may fail offline
      });
    });
  }

  document.addEventListener("DOMContentLoaded", initThemeToggle);
})();

